var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"d":"M28 4h-2.92l-6.28 9.723L12.52 4H4l7.76 11.98-7.6 11.979h8.36l6.28-9.682L25.04 28H28l-7.76-12.02L28 4zM11.28 25.374H8.64l6.04-9.394L8.6 6.543h2.64l6.08 9.436-6.04 9.394z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }